import { FieldArray } from "formik";
import { Button, Divider, Grid, IconButton, Typography } from "@mui/material";
import InputField from "../../../utils/FormFields/InputField";
import SwitchField from "../../../utils/FormFields/ActiveField";
import { FormikProps, FormikValues, useFormikContext } from "formik";
import { ServicesObjectInner } from "../../../api/clinic-management";
import { IconListDetails, IconTrash } from "@tabler/icons";

const BranchServices = () => {
  const formik: FormikProps<FormikValues> = useFormikContext();

  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 1 }}>
        Branch Services
      </Typography>
      <Divider />
      <Grid container rowSpacing={4} spacing={2} sx={{ pt: 8, justifyContent: "center", alignContent: "center" }}>
        <FieldArray
          name="Services"
          render={(arrayHelpers) => (
            <>
              <Button
                onClick={() => {
                  arrayHelpers.push({ Service: "", Active: true });
                }}
                color="primary"
                variant="outlined"
                sx={{ p: 1 }}
              >
                <IconListDetails />
                Add Service
              </Button>
              <Grid container />
              {formik?.values?.Services.map((service: ServicesObjectInner, index: number) => (
                <>
                  <Grid item xs={12} sm={5} key={index}>
                    <InputField name={`Services[${index}].Service`} label="Service" fullWidth />
                  </Grid>
                  <Grid item xs={8} sm={2}>
                    <SwitchField
                      name={`Services[${index}].Active`}
                      label="Active"
                      index={index}
                      defaultChecked={true}
                      value={service?.Active}
                    />
                  </Grid>
                  <Grid item xs={4} sm={1}>
                    <IconButton onClick={() => arrayHelpers.remove(index)}>
                      <IconTrash color="red" />
                    </IconButton>
                  </Grid>
                </>
              ))}
            </>
          )}
        />
      </Grid>
    </>
  );
};

export default BranchServices;
